module.exports = __webpack_public_path__ + "media/images/star-no-b77146fbbd85f7f604cfaa627750c479.svg";